import { render, staticRenderFns } from "./ProductsCard.vue?vue&type=template&id=1f7ed7ce&scoped=true"
import script from "./ProductsCard.vue?vue&type=script&lang=js"
export * from "./ProductsCard.vue?vue&type=script&lang=js"
import style0 from "./ProductsCard.vue?vue&type=style&index=0&id=1f7ed7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7ed7ce",
  null
  
)

export default component.exports